import { ContentCardLocation } from './data';

export const AnalyticFlows: Record<ContentCardLocation, string> = {
  summaryOverlayNotice: 'Summary',
  summaryLegalBanner: 'Summary',
  summaryGuide: 'Summary',
  summaryAccountLevelBanner: 'Summary',
  summarySecondaryCard: 'Summary',
  envelopeAccountPageGuide: 'Envelopes Account Overview',
  envelopeAccountPageSecondaryCard: 'Envelopes Account Overview',
  accountOverviewGuide: 'Goal Overview',
  accountOverviewSecondaryCard: 'Goal Overview',
  rewardsCard: 'Rewards Center',
  accountWithdrawal401k: 'Account Withdrawal 401K',
};

export const LocationMessageCounts: Record<ContentCardLocation, number> = {
  summaryOverlayNotice: 1,
  summaryLegalBanner: 1,
  summaryGuide: 1,
  summaryAccountLevelBanner: 1,
  summarySecondaryCard: 1,
  envelopeAccountPageGuide: 1,
  envelopeAccountPageSecondaryCard: 1,
  accountOverviewGuide: 1,
  accountOverviewSecondaryCard: 1,
  rewardsCard: 3,
  accountWithdrawal401k: 1,
};
